import { createAction, handleActions } from 'redux-actions'
import jwtDecode from 'jwt-decode'
import * as globalMessageActions from '../global-message'
import Y from '../../y18n'
import api from '../api'
import * as localesActions from '../locales'

export const LOGIN = createAction('account/LOGIN')
export const LOGIN_SUCCESS = createAction('account/LOGIN_SUCCESS')
export const LOGIN_ERROR = createAction('account/LOGIN_ERROR')

export const GET_DETAILED_PROFILE = createAction('account/GET_DETAILED_PROFILE')
export const GET_DETAILED_PROFILE_SUCCESS = createAction('account/GET_DETAILED_PROFILE_SUCCESS')
export const GET_DETAILED_PROFILE_ERROR = createAction('account/GET_DETAILED_PROFILE_ERROR')

export const UPDATE_DETAILED_PROFILE = createAction('account/UPDATE_DETAILED_PROFILE')
export const SAVE_DETAILED_PROFILE = createAction('account/SAVE_DETAILED_PROFILE')
export const SAVE_DETAILED_PROFILE_SUCCESS = createAction('account/SAVE_DETAILED_PROFILE_SUCCESS')
export const SAVE_DETAILED_PROFILE_ERROR = createAction('account/SAVE_DETAILED_PROFILE_ERROR')

export const REGISTER = createAction('account/REGISTER')
export const REGISTER_SUCCESS = createAction('account/REGISTER_SUCCESS')
export const REGISTER_ERROR = createAction('account/REGISTER_ERROR')

export const FORGOT_PASSWORD = createAction('account/FORGOT_PASSWORD')
export const FORGOT_PASSWORD_SUCCESS = createAction('account/FORGOT_PASSWORD_SUCCESS')
export const FORGOT_PASSWORD_ERROR = createAction('account/FORGOT_PASSWORD_ERROR')

export const SET_PASSWORD = createAction('account/SET_PASSWORD')
export const SET_PASSWORD_SUCCESS = createAction('account/SET_PASSWORD_SUCCESS')
export const SET_PASSWORD_ERROR = createAction('account/SET_PASSWORD_ERROR')

export const CHANGE_PASSWORD = createAction('account/CHANGE_PASSWORD')
export const CHANGE_PASSWORD_SUCCESS = createAction('account/CHANGE_PASSWORD_SUCCESS')
export const CHANGE_PASSWORD_ERROR = createAction('account/CHANGE_PASSWORD_ERROR')

export const SET_PROFILE = createAction('account/SET_PROFILE')

export const SET_PASSWORD_TICKET = createAction('account/SET_PASSWORD_TICKET')

export const LOGOUT = createAction('account/LOGOUT')

const initialState = {
  loading: false,
  isAuthenticated: false,
  error: null,
  loginError: null,
  registerError: null,
  profile: {},
  detailedProfile: {},
  passwordTicketId: null
}

export default handleActions(
  {
    [LOGIN]: (state, action) => ({
      ...state,
      loading: true,
      loginError: null
    }),
    [LOGIN_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      isAuthenticated: true
    }),
    [LOGIN_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      loginError: action.payload
    }),
    [GET_DETAILED_PROFILE]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_DETAILED_PROFILE_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      detailedProfile: action.payload
    }),
    [GET_DETAILED_PROFILE_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload
    }),
    [UPDATE_DETAILED_PROFILE]: (state, action) => {
      var detailedProfile = state.detailedProfile
      detailedProfile[action.payload.name] = action.payload.value
      return { ...state, detailedProfile: detailedProfile }
    },
    [SAVE_DETAILED_PROFILE]: (state, action) => ({
      ...state,
      loading: true,
      error: null
    }),
    [SAVE_DETAILED_PROFILE_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [SAVE_DETAILED_PROFILE_ERROR]: (state, action) => ({
      ...state,
      error: action.payload,
      loading: false
    }),
    [REGISTER]: (state, action) => ({
      ...state,
      loading: true,
      registerError: null
    }),
    [REGISTER_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [REGISTER_ERROR]: (state, action) => ({
      ...state,
      registerError: action.payload,
      loading: false
    }),
    [FORGOT_PASSWORD]: (state, action) => ({
      ...state,
      loading: true,
      error: null
    }),
    [FORGOT_PASSWORD_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [FORGOT_PASSWORD_ERROR]: (state, action) => ({
      ...state,
      error: action.payload,
      loading: false
    }),
    [SET_PASSWORD]: (state, action) => ({
      ...state,
      loading: true,
      error: null
    }),
    [SET_PASSWORD_SUCCESS]: (state, action) => {
      var profile = state.profile
      profile.email = action.payload
      return { ...state, loading: false, profile: profile }
    },
    [SET_PASSWORD_ERROR]: (state, action) => ({
      ...state,
      error: action.payload,
      loading: false
    }),
    [CHANGE_PASSWORD]: (state, action) => ({
      ...state,
      loading: true,
      error: null
    }),
    [CHANGE_PASSWORD_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [CHANGE_PASSWORD_ERROR]: (state, action) => ({
      ...state,
      error: action.payload,
      loading: false
    }),
    [SET_PROFILE]: (state, action) => ({
      ...state,
      profile: action.payload
    }),
    [SET_PASSWORD_TICKET]: (state, action) => ({
      ...state,
      passwordTicketId: action.payload,
      loading: false
    }),
    [LOGOUT]: (state, action) => ({
      ...state,
      isAuthenticated: false,
      profile: {}
    })
  },
  initialState
)

export const login = (email, password) => {
  return dispatch => {
    dispatch(LOGIN())
    return api
      .login({ email: email, password: password })
      .then(result => {
        if (result && typeof result === 'string') {
          dispatch(SET_PASSWORD_TICKET(result))
        } else {
          let token = localStorage.getItem('id_token')
          dispatch(profileFromToken(token))
        }
      })
      .catch(error => {
        if (error === 'Unauthorized') {
          dispatch(LOGIN_ERROR('Login failed! Please verify that the email and password is correct and try again'))
        } else if (error === 'No password set') {
          dispatch(
            LOGIN_ERROR(
              'No password has been set for this user. Please follow the link in the email you received from us to set a password or click forgot password and enter your email address to request a new link'
            )
          )
        } else if (error === 'Failed to fetch' || error === 'Internal Server Error') {
          dispatch(LOGIN_ERROR('An internal server error occured. Please try again in a little while'))
        } else {
          dispatch(LOGIN_ERROR(error))
        }
      })
  }
}

export const getDetailedProfile = userId => {
  return dispatch => {
    dispatch(GET_DETAILED_PROFILE())
    return api
      .get('account/getprofile', userId)
      .then(result => {
        dispatch(GET_DETAILED_PROFILE_SUCCESS(result))
      })
      .catch(error => {
        GET_DETAILED_PROFILE_ERROR()
      })
  }
}

export const updateDetailedProfile = (name, value) => {
  return dispatch => {
    dispatch(UPDATE_DETAILED_PROFILE({ name, value }))
  }
}

export const saveDetailedProfile = detailedProfile => {
  return (dispatch, getState) => {
    dispatch(SAVE_DETAILED_PROFILE())
    const id = getState().accounts.profile.userId
    return api
      .post('account/update', id, detailedProfile)
      .then(result => {
        dispatch(SAVE_DETAILED_PROFILE_SUCCESS())
        dispatch(localesActions.setLanguage(detailedProfile.language))
        dispatch(localesActions.setCountry(detailedProfile.country))
        dispatch(globalMessageActions.setGlobalSuccess(Y`Profile updated`))
      })
      .catch(error => {
        SAVE_DETAILED_PROFILE_ERROR(error)
      })
  }
}

export const forgotPassword = email => {
  return dispatch => {
    dispatch(FORGOT_PASSWORD())
    return api
      .post('account/forgotpassword', '', email)
      .then(result => {
        dispatch(FORGOT_PASSWORD_SUCCESS(result))
        dispatch(globalMessageActions.setGlobalSuccess(Y`Email with password recovery link sent`))
      })
      .catch(error => {
        dispatch(FORGOT_PASSWORD_ERROR(error))
      })
  }
}

export const register = model => {
  return dispatch => {
    dispatch(REGISTER())
    if (model.countryCode !== 'other') {
      model.phoneNumber = `${model.countryCode}${model.phoneNumber}`
    }
    return api
      .post('account/register', '', model)
      .then(result => {
        dispatch(REGISTER_SUCCESS())
      })
      .catch(error => {
        dispatch(REGISTER_ERROR(error))
      })
  }
}

export const logout = () => {
  return dispatch => {
    localStorage.removeItem('id_token')
    if (document.cookie.indexOf('jwt=') !== -1) {
      document.cookie = `jwt=;`
    }
    dispatch(LOGOUT())
  }
}

export const setPassword = (ticketId, password) => {
  return dispatch => {
    dispatch(SET_PASSWORD())
    return api
      .post('account/setpassword', ticketId, password)
      .then(result => {
        dispatch(SET_PASSWORD_SUCCESS(result))
        dispatch(globalMessageActions.setGlobalSuccess(Y`Password successfully set`))
      })
      .catch(error => {
        dispatch(SET_PASSWORD_ERROR(error))
      })
  }
}

export const changePassword = (userId, oldPassword, newPassword) => {
  return dispatch => {
    dispatch(CHANGE_PASSWORD())
    return api
      .post('account/changepassword', userId, { oldPassword: oldPassword, newPassword: newPassword })
      .then(result => {
        dispatch(CHANGE_PASSWORD_SUCCESS())
        dispatch(globalMessageActions.setGlobalSuccess(Y`Password successfully changed`))
      })
      .catch(error => {
        dispatch(CHANGE_PASSWORD_ERROR(error))
        dispatch(globalMessageActions.setGlobalError(Y`An error occured. Your password could not be changed`))
      })
  }
}

export const getTokenExpirationDate = token => {
  const decoded = jwtDecode(token)
  if (!decoded.exp) return null
  const date = new Date(0) // The 0 here is the key, which sets the date to the epoch
  date.setUTCSeconds(decoded.exp)
  return date
}

export const isTokenValid = token => {
  if (!token) return false
  const date = this.getTokenExpirationDate(token)
  if (date === null) return false
  return date.valueOf() > new Date().valueOf()
}

export const profileFromToken = token => {
  return dispatch => {
    if (token && isTokenValid(token)) {
      const decoded = jwtDecode(token)
      const profile = {
        role: decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'],
        userId: decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'],
        firstName: decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname'],
        lastName: decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname'],
        email: decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'],
        emailVerified: decoded['emailVerified'],
        language: decoded['language'],
        tempPassword: decoded['tempPassword']
      }
      dispatch(SET_PROFILE(profile))
      dispatch(localesActions.setLanguage(profile.language))
      dispatch(LOGIN_SUCCESS())
      if (profile.role === 'Admin' || profile.role === 'SuperAdmin') {
        document.cookie = `jwt=${token}`
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/accounts/index.js